import { render, staticRenderFns } from "./BandwidthPricing.vue?vue&type=template&id=337cec68&scoped=true&"
import script from "./BandwidthPricing.vue?vue&type=script&lang=js&"
export * from "./BandwidthPricing.vue?vue&type=script&lang=js&"
import style0 from "./BandwidthPricing.vue?vue&type=style&index=0&id=337cec68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337cec68",
  null
  
)

export default component.exports